import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

function Email({ senderName, subject }) {
  return (
    <S.EmailWrapper>
      <S.SenderName variant="caption3ExtraBold">{senderName || `{senderName}`}</S.SenderName>
      <S.SubjectLine variant="caption3Bold">
        {subject || `{senderName} just sent you a gift! 🎁`}
      </S.SubjectLine>
      <S.Overlay1 isActive={senderName} />
      <S.Overlay2 isActive={senderName} />
    </S.EmailWrapper>
  );
}

Email.propTypes = {
  senderName: PropTypes.string,
  subject: PropTypes.string
};

export { Email };
